/**
 * Created by Ivan on 19.01.2026
 */

const KingsCupExtraBarIcon = {
    customIcon: function () {
        return Prefab.instantiate(bundles.questsgroupicon.jsons.kingscup_extrabar_icon_prefab_json);
    },
    extraBarWeight: 100002
};
